import type { UsageSummary } from "../types";
import { formatCost } from "../utils/format";

type Total = { label: string; value: string; note?: string };

export const UsageTotals = ({ summary }: { summary: UsageSummary }) => {
  const average = summary.runs ? summary.cost_usd / summary.runs : 0;
  const totals: Total[] = [
    { label: "Runs", value: summary.runs.toLocaleString() },
    { label: "Total cost", value: formatCost(summary.cost_usd) },
    { label: "Average cost per run", value: formatCost(average) },
    {
      label: "Entries without a price",
      value: summary.unpriced_events.toLocaleString(),
      note: "Not in the costs. Read-once has no price, and some models have no known price.",
    },
  ];

  return (
    <dl className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {totals.map((total) => (
        <div key={total.label} className="rounded-[3px] border border-zinc-200 px-4 py-3">
          <dt className="text-xs font-medium text-zinc-500">{total.label}</dt>
          <dd className="mt-1 text-2xl font-semibold tabular-nums text-zinc-900">
            {total.value}
          </dd>
          {total.note && <dd className="mt-1 text-xs text-zinc-500">{total.note}</dd>}
        </div>
      ))}
    </dl>
  );
};
